import { IAoo, IArxeiaConfiguration, IFeature, IField, IRuolo, ISearchField, IUor } from '../../shared/interfaces'
import { IUserInfoDTO } from '../../shared/interfacesDTO';

export interface SessionState {
    currentUser?: IUserInfoDTO;
    currentAoo?: IAoo;
    currentUor?: IUor;
    userActiveAoo?: IAoo[];
    allRoles?: IRuolo[];
    features?: IFeature[];
    arxeiaConfigurations?: IArxeiaConfiguration[];
    isMobile?: boolean;
    isTablet?: boolean;
    sidebarMenuIsOpen?: boolean;
    aooMenuIsOpen?: boolean;
    indicePAFormFields: IField[],
    organigrammaFlat: IUor[] | undefined,
    campiProtocolloViewFields: IField[] | undefined,
    campiRicercaViewFields: IField[] | undefined,
    campiRicercaAreaLavoroViewFields: IField[] | undefined,
    tuttiIProtocolliViewFields: IField[] | undefined,
    serchAiFields: ISearchField[] | undefined,
}

export const UPDATE_SESSION = 'UPDATE_SESSION'
interface UpdateSessionAction {
    type: typeof UPDATE_SESSION
    payload: Partial<SessionState>
}

export type SessionActionTypes = UpdateSessionAction